import { SearchParams } from '../searches/types'
import { Count, Estimate, EstimateItem } from '../types'

/** TYPES **/
export const estimatesTypes = {
  FETCH_ESTIMATES: 'FETCH_ESTIMATES',
  FETCH_RELATED_ESTIMATES: 'FETCH_RELATED_ESTIMATES',
  SET_ESTIMATES: 'SET_ESTIMATES',
  SET_RELATED_ESTIMATES: 'SET_RELATED_ESTIMATES',
  FETCH_ESTIMATE_COUNTS: 'FETCH_ESTIMATE_COUNTS',
  SET_ESTIMATES_COUNTS: 'SET_ESTIMATES_COUNTS',
  UPDATE_ESTIMATE: 'UPDATE_ESTIMATE',
  CREATE_ESTIMATE: 'CREATE_ESTIMATE',
  RELEASE_ESTIMATE: 'RELEASE_ESTIMATE',
  RELEASE_HOMEPLAN_ESTIMATE: 'RELEASE_HOMEPLAN_ESTIMATE',
  DOWNLOAD_ESTIMATE_CSV: 'DOWNLOAD_ESTIMATE_CSV',
  GET_ESTIMATES_CSV: 'GET_ESTIMATES_CSV',
  SET_ESTIMATES_CSV: 'SET_ESTIMATES_CSV',
  ASSIGN_MULTIPLE_ESTIMATES: 'ASSIGN_MULTIPLE_ESTIMATES',
}


/** ACTIONS **/
export interface FetchEstimatesActions {
  type: typeof estimatesTypes.FETCH_ESTIMATES
  payload: {
    page?: number,
    size?: number,
    searchParams?: Partial<SearchParams>
  }
  callback?: (succ: boolean) => void
}
export interface FetchRelatedEstimatesAction {
  type: typeof estimatesTypes.FETCH_RELATED_ESTIMATES
  payload: string
  callback?: (succ: boolean) => void
}

export interface CreateEstimateActions {
  type: typeof estimatesTypes.CREATE_ESTIMATE
  payload: Partial<Partial<EstimateItem>>
  callback?: (succ: boolean, estimateId: string | null) => void
}

export interface UpdateEstimateActions {
  type: typeof estimatesTypes.UPDATE_ESTIMATE
  payload: Partial<EstimateItem>
  callback?: (succ: boolean) => void
}

export interface SetEstimatesAction {
  type: typeof estimatesTypes.SET_ESTIMATES
  payload: Estimate
}

export interface SetRelatedEstimatesAction {
  type: typeof estimatesTypes.SET_RELATED_ESTIMATES
  payload: EstimateItem[]
}

export interface SetJobsCountsAction {
  type: typeof estimatesTypes.SET_ESTIMATES_COUNTS
  payload: Count[]
}

export interface ReleaseEstimateAction {
  type: typeof estimatesTypes.RELEASE_ESTIMATE
  payload: {
    estimateId: string,
    releaseEstimateRequest: ReleaseEstimateRequest
  }
  callback?: (succ: boolean) => void
}

export interface ReleaseHomeplanEstimateAction {
  type: typeof estimatesTypes.RELEASE_HOMEPLAN_ESTIMATE
  payload: string,
  callback?: (succ: boolean) => void
}

export interface SendTo {
  name: string,
  email: string,
}

export interface ReleaseEstimateRequest {
  sendToList: SendTo[],
  emailSubject: string,
  notes: string,
}


export interface GetCSVEstimateAction {
  type: typeof estimatesTypes.DOWNLOAD_ESTIMATE_CSV,
  payload: string,
  callback: (succ: boolean, csvUrl?: string) => void
}

export interface DownloadCSVEstimateAction {
  type: typeof estimatesTypes.DOWNLOAD_ESTIMATE_CSV,
  payload: { searchParams?: Partial<SearchParams> },
  callback: (succ: boolean, csvUrl?: string) => void
}

export interface AssignMultipleEstimatesAction {
  type: typeof estimatesTypes.ASSIGN_MULTIPLE_ESTIMATES,
  payload: {
    estimateIds: string[],
    estimatorId: string
  }
  callback: (succ: boolean) => void
}

export type EstimatesActions =
  | FetchEstimatesActions
  | FetchRelatedEstimatesAction
  | UpdateEstimateActions
  | SetEstimatesAction
  | SetRelatedEstimatesAction
  | SetJobsCountsAction
  | ReleaseEstimateAction
  | ReleaseHomeplanEstimateAction
  | DownloadCSVEstimateAction
  | GetCSVEstimateAction
  | AssignMultipleEstimatesAction
  
export type EstimatesType = Estimate
